import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { SecondaryBody } from 'scy/text';
import { accent } from 'scy/text/styles.mod.scss';
import BackArrow from 'images/icons/controls/arrow-back.svg?react-svg';
import {
  absolute,
  top_xxs,
  left_xs,
  tablet_top_sm,
  tablet_left_lg
} from 'scy/position.mod.scss';
import { hidden, tablet_inline } from 'scy/display.mod.scss';
import { flex, centerItems } from 'scy/flex.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function WizardNav({ className, prevPath, children }) {
  return (
    <nav className={classnames(className, styles.nav)}>
      <Link
        to={prevPath}
        className={`${absolute} ${top_xxs} ${left_xs}
          ${tablet_top_sm} ${tablet_left_lg}
          ${padding.sm} ${flex} ${centerItems} ${accent}`}
      >
        <BackArrow />
        <SecondaryBody
          className={`${hidden} ${tablet_inline} ${margin.left_sm}`}
        >
          Back
        </SecondaryBody>
      </Link>
      {children}
    </nav>
  );
}
